import { useState, useEffect, useRef } from "react";
import DifficultyDropdown from "./DropDownBoxes/DifficultyDropdown";
import TopicDropdown from "./DropDownBoxes/TopicDropwdown";
import ModaityDropdown from "./DropDownBoxes/ModalityDropdown";
import "./SearchBar.css"


export default function SearchBar({set_searchbar_content, difficulty_checkboxes, set_difficulty_checkboxes, topic_checkboxes, set_topic_checkboxes, modality_checkboxes, set_modality_checkboxes}){
    const [difficulty_ref_selected, set_difficulty_ref_selected] = useState(false);
    const [topic_ref_selected, set_topic_ref_selected] = useState(false);
    const [modality_ref_selected, set_modality_ref_selected] = useState(false);
    const difficultyRef = useRef(null);
    const topicRef = useRef(null);
    const modalityRef = useRef(null);
    useEffect(() => {

        const handleClickOutside = (event) => {
            // Check that the ref is not not null (redundant)
            // Then make sure we are not selecting the button itself
            if (difficultyRef.current && !difficultyRef.current.contains(event.target)) {
                set_difficulty_ref_selected(false);
            }
            if(topicRef.current && !topicRef.current.contains(event.target)){
                set_topic_ref_selected(false);
            }
            if(modalityRef.current && !modalityRef.current.contains(event.target)){
                set_modality_ref_selected(false);
            }
        };

        window.addEventListener("click", handleClickOutside);

        return () => {
            window.removeEventListener("click", handleClickOutside);
        };

    }, []);
        
   
    return(
        <>
            <div className="search-container">
                <div className="problems-box">

                    <input placeholder="Problem Name" className="search-by-name box"
                        onChange={(event) => set_searchbar_content(event.target.value)}
                    />

                    <div className="difficulty-wrapper" ref={difficultyRef}>
                        
                        <div className="difficulty box" onClick={() => set_difficulty_ref_selected(!difficulty_ref_selected)} >
                            Difficulty {!difficulty_ref_selected ? <i className="arrow up"/>:<i className="arrow down"/>}
                        </div>

                        <div>
                            <div className="difficulty-dropdown">
                                    {difficulty_ref_selected && 
                                    <DifficultyDropdown 
                                        difficulty_checkboxes={difficulty_checkboxes} set_difficulty_checkboxes={set_difficulty_checkboxes}/>}
                            </div>
                        </div>
                       
                    </div>
                        
                    
                    <div className="topic-wrapper" ref={topicRef}>

                        <div className="topic box" onClick={() => set_topic_ref_selected(!topic_ref_selected)}>
                            Topic {!topic_ref_selected ? <i className="arrow up"/> : <i className="arrow down"/>}
                        </div>

                        <div>
                            <div className="topic-dropdown">
                                {topic_ref_selected && <TopicDropdown   topic_checkboxes={topic_checkboxes} set_topic_checkboxes={set_topic_checkboxes}/>}
                            </div>
                        </div>
                        
                    </div>

                    <div className="modality-wrapper" ref={modalityRef}>

                        <div className="modality box" onClick={() => set_modality_ref_selected(!modality_ref_selected)}>
                            Modality {!modality_ref_selected ? <i className="arrow up"/> : <i className="arrow down"/>}
                        </div>

                        <div>
                            <div className="modaity-dropdown">
                               {modality_ref_selected && <ModaityDropdown modality_checkboxes={modality_checkboxes} set_modality_checkboxes={set_modality_checkboxes}/>} 
                            </div>
                        </div>

                    </div>

                </div>
                
            </div>
        </>
        
    );
}